import { ReactNode } from 'react'
import styled from 'styled-components'
import { Badge, Box, Text } from '@machobear/design-system'

const Counter = styled.span`
  position: absolute;
  font-size: 9px;
  line-height: 16px;
  right: -6px;
  top: -6px;
  z-index: 100;
  color: white;
  font-weight: 700;
  background-color: #fe5f55;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  text-align: center;
`

interface Props {
  icon: ReactNode
  text: string
  onClick: () => void
  badge?: string
  counter?: number
  disabled?: boolean
  tone?: 'disabled' | 'critical' | 'formAccent'
}

export const ActionMenuItem = ({
  icon,
  text,
  onClick,
  tone = 'formAccent',
  disabled = false,
  counter = 0,
  badge
}: Props) => (
  <Box
    display="flex"
    flexDirection="row"
    alignItems="center"
    gap="xxsmall"
    padding="none"
    margin="none"
    cursor={disabled ? 'default' : 'pointer'}
    style={{ height: '44px' }}
    onClick={disabled ? undefined : onClick}
    data={{ testid: text }}
  >
    <Box style={{ position: 'relative', flex: 0 }}>
      {icon}
      {counter > 0 && <Counter>{counter}</Counter>}
    </Box>

    <Box
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <Text weight="strong" tone={disabled ? 'disabled' : tone}>
        {text}
      </Text>
      {badge && <Badge tone="positive">{badge}</Badge>}
    </Box>
  </Box>
)
